import { observer } from "mobx-react";
import React from "react";
import styled, { createGlobalStyle } from "styled-components";

import reloadImage from "./images/reload.svg";

const Wrapper = styled.div``;
const Button = styled.div`
  width: 16px;
  height: 16px;
  background: url("${reloadImage}") no-repeat center;
  cursor: pointer;
`;
const GlobalStyle = createGlobalStyle`
  .reload-animation {
    transform: rotate(360deg);
    transition: transform 1s cubic-bezier(0, 1.4, 1, 1);
  }
`;

type Props = {
  onClick: () => void;
  style: React.CSSProperties;
};
@observer
class ReloadButton extends React.Component<Props> {
  wrapper: HTMLElement | null = null;
  timeout: NodeJS.Timeout | null = null;

  onClick() {
    if (this.timeout) {
      return;
    }

    if (this.props.onClick) {
      this.props.onClick();
    }

    if (!this.wrapper) {
      return;
    }

    this.wrapper.className += " reload-animation";
    this.timeout = setTimeout(() => {
      this.wrapper!.className = this.wrapper!.className.substr(
        0,
        this.wrapper!.className.indexOf(" reload-animation"),
      );
      this.timeout = null;
    }, 1000);
  }

  render() {
    return (
      <Wrapper>
        <Button
          ref={(div: any) => {
            this.wrapper = div;
          }}
          {...this.props}
          onClick={() => {
            this.onClick();
          }}
        />
        <GlobalStyle />
      </Wrapper>
    );
  }
}

export default ReloadButton;
